// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-internal API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto } from '../model/collectionResultOfCrmGebruikersGetGebruikersLikeStringDto.ts';

import type { CollectionResultOfCrmMedewerkersMedewerkerDto } from '../model/collectionResultOfCrmMedewerkersMedewerkerDto.ts';

import type { GebruikerFotoUploadenBody } from '../model/gebruikerFotoUploadenBody.ts';

import type { GebruikerSearchParams } from '../model/gebruikerSearchParams.ts';

import type { Result1OfCrmGebruikersGebruikerDto } from '../model/result1OfCrmGebruikersGebruikerDto.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
 * @summary Zoek naar gebruikers
 */
export const gebruikerSearch = (
  params?: MaybeRefOrGetter<GebruikerSearchParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto>(
    { url: `/api/v1/gebruikers/search`, method: 'GET', params, signal },
    options,
  );
};

export const getGebruikerSearchQueryKey = (params?: MaybeRefOrGetter<GebruikerSearchParams>) => {
  return ['api', 'v1', 'gebruikers', 'search', ...(params ? [params] : [])] as const;
};

export const getGebruikerSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof gebruikerSearch>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<GebruikerSearchParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof gebruikerSearch>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGebruikerSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof gebruikerSearch>>> = ({ signal }) =>
    gebruikerSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof gebruikerSearch>>,
    TError,
    TData
  >;
};

export type GebruikerSearchQueryResult = NonNullable<Awaited<ReturnType<typeof gebruikerSearch>>>;
export type GebruikerSearchQueryError = ErrorType<void>;

/**
 * @summary Zoek naar gebruikers
 */

export function useGebruikerSearch<
  TData = Awaited<ReturnType<typeof gebruikerSearch>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<GebruikerSearchParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof gebruikerSearch>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGebruikerSearchQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
 * @summary Gebruiker ophalen
 */
export const gebruikerGet = (
  gebruikerId: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  gebruikerId = toValue(gebruikerId);

  return customInstance<Result1OfCrmGebruikersGebruikerDto>(
    { url: `/api/v1/gebruikers/${gebruikerId}`, method: 'GET', signal },
    options,
  );
};

export const getGebruikerGetQueryKey = (
  gebruikerId: MaybeRefOrGetter<number | undefined | null>,
) => {
  return ['api', 'v1', 'gebruikers', gebruikerId] as const;
};

export const getGebruikerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof gebruikerGet>>,
  TError = ErrorType<void>,
>(
  gebruikerId: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof gebruikerGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGebruikerGetQueryKey(gebruikerId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof gebruikerGet>>> = ({ signal }) =>
    gebruikerGet(gebruikerId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => toValue(gebruikerId) !== null && toValue(gebruikerId) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof gebruikerGet>>, TError, TData>;
};

export type GebruikerGetQueryResult = NonNullable<Awaited<ReturnType<typeof gebruikerGet>>>;
export type GebruikerGetQueryError = ErrorType<void>;

/**
 * @summary Gebruiker ophalen
 */

export function useGebruikerGet<
  TData = Awaited<ReturnType<typeof gebruikerGet>>,
  TError = ErrorType<void>,
>(
  gebruikerId: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof gebruikerGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGebruikerGetQueryOptions(gebruikerId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.Adviseurbeheer</li></ul>
 * @summary Upload een profielfoto voor een gebruiker.
 */
export const gebruikerFotoUploaden = (
  gebruikerId: MaybeRefOrGetter<number | undefined | null>,
  gebruikerFotoUploadenBody?: MaybeRefOrGetter<GebruikerFotoUploadenBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  gebruikerId = toValue(gebruikerId);
  gebruikerFotoUploadenBody = toValue(gebruikerFotoUploadenBody);
  const formData = new FormData();
  if (gebruikerFotoUploadenBody?.file !== undefined) {
    formData.append(`file`, gebruikerFotoUploadenBody.file);
  }

  return customInstance<void>(
    {
      url: `/api/v1/gebruikers/${gebruikerId}/profielfoto`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getGebruikerFotoUploadenMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof gebruikerFotoUploaden>>,
    TError,
    GebruikerFotoUploadenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof gebruikerFotoUploaden>>,
  TError,
  GebruikerFotoUploadenMutationVariables,
  TContext
> => {
  const mutationKey = ['gebruikerFotoUploaden'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof gebruikerFotoUploaden>>,
    GebruikerFotoUploadenMutationVariables
  > = (props) => {
    const { gebruikerId, data } = props ?? {};

    return gebruikerFotoUploaden(gebruikerId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GebruikerFotoUploadenMutationResult = NonNullable<
  Awaited<ReturnType<typeof gebruikerFotoUploaden>>
>;
export type GebruikerFotoUploadenMutationBody = GebruikerFotoUploadenBody | undefined;
export type GebruikerFotoUploadenMutationError = ErrorType<void>;
export type GebruikerFotoUploadenMutationVariables = {
  gebruikerId: number | undefined | null;
  data?: GebruikerFotoUploadenBody;
};

/**
 * @summary Upload een profielfoto voor een gebruiker.
 */
export const useGebruikerFotoUploaden = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof gebruikerFotoUploaden>>,
      TError,
      GebruikerFotoUploadenMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof gebruikerFotoUploaden>>,
  TError,
  GebruikerFotoUploadenMutationVariables,
  TContext
> => {
  return useMutation(getGebruikerFotoUploadenMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
 * @summary Haal alle werkverdeling gebruikers op.
 */
export const gebruikerGetWerkverdelingGebruikers = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CollectionResultOfCrmMedewerkersMedewerkerDto>(
    { url: `/api/v1/gebruikers/werkverdeling`, method: 'GET', signal },
    options,
  );
};

export const getGebruikerGetWerkverdelingGebruikersQueryKey = () => {
  return ['api', 'v1', 'gebruikers', 'werkverdeling'] as const;
};

export const getGebruikerGetWerkverdelingGebruikersQueryOptions = <
  TData = Awaited<ReturnType<typeof gebruikerGetWerkverdelingGebruikers>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof gebruikerGetWerkverdelingGebruikers>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGebruikerGetWerkverdelingGebruikersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof gebruikerGetWerkverdelingGebruikers>>> = ({
    signal,
  }) => gebruikerGetWerkverdelingGebruikers(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof gebruikerGetWerkverdelingGebruikers>>,
    TError,
    TData
  >;
};

export type GebruikerGetWerkverdelingGebruikersQueryResult = NonNullable<
  Awaited<ReturnType<typeof gebruikerGetWerkverdelingGebruikers>>
>;
export type GebruikerGetWerkverdelingGebruikersQueryError = ErrorType<void>;

/**
 * @summary Haal alle werkverdeling gebruikers op.
 */

export function useGebruikerGetWerkverdelingGebruikers<
  TData = Awaited<ReturnType<typeof gebruikerGetWerkverdelingGebruikers>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof gebruikerGetWerkverdelingGebruikers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGebruikerGetWerkverdelingGebruikersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
